import { useReactTable, getCoreRowModel, createColumnHelper } from '@tanstack/react-table';
import { Location } from '../../Clients/reminds';
import { useLocationsContext } from '../../Contexts/Locations.Context';
import Table from '../../Components/Table/Table';
import { Remove } from '../../Icons/Remove';
import Map from '../../Components/Map/Map.component';

const columnHelper = createColumnHelper<Location>();

const defaultColumns = [
  columnHelper.accessor('name', {
    header: 'Name',
  }),
  columnHelper.accessor('placeId', {
    header: 'Place',
    cell: props => {
      return (
        <a
          href={`https://www.google.com/maps/place/?q=place_id:${props.getValue()}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Maps
        </a>
      );
    },
  }),
  columnHelper.accessor('id', {
    header: 'id',
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: props => {
      return <DeleteButton id={props.row.original.id} />;
    },
  }),
];
export const LocationsTable = () => {
  const { data = [] } = useLocationsContext();

  const table = useReactTable({
    data,
    columns: defaultColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <Table table={table}></Table>
      <Map locations={data}></Map>
    </div>
  );
};

const DeleteButton: React.FC<{ id: number | undefined }> = ({ id }) => {
  const { deleteLocation } = useLocationsContext();

  const handleDelete = () => {
    if (id) deleteLocation(id);
  };

  return <Remove onRemove={handleDelete} />;
};
